export default __webpack_public_path__ + "static/media/Clan Bound Leggings of the Everlasting Sky.e3b664dd.jpg";